<div *ngIf='componentReady' [formGroup]='inputForm' class='SendToCampaignDialog'>
  <div class='row'>
    <div class='col col-12'>
      <div class='alert alert-warning'>
        <p>Please ensure you've attached the desired campaign to relevant contact groups. <br>After you select a
          campaign,
          the contact groups attached to the selected campaign will appear.</p>
      </div>
    </div>
  </div>
  <div class='row'>
    <div class='col col-6'>
      <mat-label>Select campaign</mat-label>
    </div>
    <div class='col col-6'>
      <app-select (selection)='onCampaignSelect($event)' [items]='campaignItems'
                  formControlName='campaign_id' label='Campaign'></app-select>
    </div>
  </div>
  <div *ngIf='groups.length' class='row mt-3'>
    <div class='col col-6'>
      <mat-label>Select group</mat-label>
    </div>
    <div class='col col-6'>
      <app-select [items]='groups' formControlName='group_id' label='Group'></app-select>
    </div>
  </div>
  <div *ngIf='group_id' class='row mt-3'>
    <div class='col col-6'>
      <mat-label>Select start date</mat-label>
    </div>
    <div class='col col-6'>
      <app-text-field [datePickerStartDate]='startDate' datePickerType='calendar' formControlName='start_date'
                      type='date'></app-text-field>
    </div>
  </div>
</div>